import Vue from "vue";
import LocalStorage from "../../libs/LocalStorage";

export default {
  state: {
    defaultPrinterTypeId: 261, //Hercules 2020
    kodakPrinterTypeId: 233,
    dualExtruders: [
      2, 5, 6, 7, 16, 17, 47, 195, 207, 212, 219, 228, 232, 233, 239, 246
    ],
    printerTypesCanRegisteredByToken: [196, 220, 233, 240, 241, 248, 235, 236],
    printerTypesMakerbot5thGen: [186, 188, 189, 213, 227],
    printerTypesIntegratedUltimaker: [212, 228, 239],
    slicer3PrinterTypes: [212,228,250,239,14,34,33,22,41,233,238,197,248,31,231,215,203,193,230,187,196,220,260,256,3840,3841,258],
    printerTypesLoaded: false,
    printerTypes: [],
    printerTypeByFile: LocalStorage.getValue(LocalStorage.PRINTER_TYPE_BY_FILE_KEY, true, {}),
    lastUsedPrinterType: LocalStorage.getValue(LocalStorage.LAST_USED_PRINTER_TYPE_KEY)
  },
  mutations: {
    SET_PRINTER_TYPES(state, printerTypes) {
      state.printerTypes = printerTypes;
    },
    PRINTER_TYPES_LOADED(state) {
      state.printerTypesLoaded = true
    },
    UPDATE_PRINTER_TYPE_BY_FILE(state, {fileId, printerTypeId}) {
      Vue.set(state.printerTypeByFile, fileId, printerTypeId);
    },
    UPDATE_LAST_USER_PRINTER_TYPE(state, printerTypeId) {
      state.lastUsedPrinterType = printerTypeId;
    }
  },

  actions: {
    async fetchPrinterTypes(context) {
      const {data} = await Vue.axios.get('/ajax/get_printer_types_newui?order=popular');
      if (data.result) {
        context.commit('SET_PRINTER_TYPES', data.message);
        context.commit('PRINTER_TYPES_LOADED');
      }
    },
    getAvailablePrinterTypes(context, printerId) {
      return Vue.axios.post('/a/print/get_printer_types', {'printer_id': printerId});
    },
    savePrinterTypeByFile(context, {fileId, printerTypeId}) {
      context.commit('UPDATE_PRINTER_TYPE_BY_FILE', {fileId, printerTypeId});
      LocalStorage.updateJsonKeyValue(LocalStorage.PRINTER_TYPE_BY_FILE_KEY, fileId, printerTypeId);
      context.dispatch('saveLastUsedPrinterType', printerTypeId);
    },
    saveLastUsedPrinterType(context, printerTypeId) {
      context.commit('UPDATE_LAST_USER_PRINTER_TYPE', printerTypeId);
      LocalStorage.setValue(LocalStorage.LAST_USED_PRINTER_TYPE_KEY, printerTypeId);
    }
  },

  getters: {
    getDualExtruders: state => {
      return state.dualExtruders;
    },
    isDualExtruderPrinter: state => printerTypeId => {
      return state.dualExtruders.indexOf(parseInt(printerTypeId)) >= 0;
    },
    isPrinterTypesLoaded: state => {
      return state.printerTypesLoaded;
    },
    getPrinterTypes: state => {
      return state.printerTypes;
    },
    getPrinterTypesUsed: state => {
      let printerTypes = state.printerTypes.filter(printerType => printerType.virtual == 'f' || printerType.used !== undefined );
      let printerTypesObject = {my: [], all: printerTypes, favourite: []};
      printerTypes.forEach((item)=>{

        if(item.used !== undefined){
          printerTypesObject.my.unshift(item)
        }
        if(item.fav > 0){
          printerTypesObject.favourite[parseInt(item.fav) - 1] = item
        }
      });

      return printerTypesObject;

    },
    getPrinterTypeIndex: state => id => {
      return state.printerTypes.findIndex(printerType => printerType.id == id);
    },
    isPrinterTypeCanRegisteredByToken: state => printerTypeId => {
      return state.printerTypesCanRegisteredByToken.indexOf(parseInt(printerTypeId)) >= 0;
    },
    isPrinterTypeMakerbot5thGen: state => printerTypeId => {
      return state.printerTypesMakerbot5thGen.indexOf(parseInt(printerTypeId)) >= 0;
    },
    isPrinterTypeIntegratedUltimaker: state => printerTypeId => {
      return state.printerTypesIntegratedUltimaker.indexOf(parseInt(printerTypeId)) >= 0;
    },
    isKodak: state => printerTypeId => {
      return parseInt(printerTypeId) === state.kodakPrinterTypeId;
    },
    isPrinterTypeSupportedBySlicer3: state => printerTypeId => {
      return state.slicer3PrinterTypes.indexOf(parseInt(printerTypeId)) >= 0;
    },
    lastUsedPrinterTypeId: state => {
      return state.lastUsedPrinterType;
    },
    getPrinterTypeIdByFileId: state => fileId => {
      return state.printerTypeByFile[fileId];
    },
    defaultPrinterTypeId: state => {
      return state.defaultPrinterTypeId;
    }
  }
}
